import { ComponentPropsWithoutRef } from 'react';

export type ButtonProps = ComponentPropsWithoutRef<'button'>;

export const Button = (props: ButtonProps) => (
  <button {...props} />
);
